<template>
    <div>
        <nav-bar></nav-bar>

        <div class="container">

            <div class="section">

                <nav class="breadcrumb" aria-label="breadcrumbs">
                    <ul>
                        <li><a @click="$router.back()">{{ CONSTANTS.getCopy('STORECLIENT_BREADCRUMB_CHATBOTS') }}</a></li>
                        <li class="is-active"><a href="#" aria-current="page">{{ CONSTANTS.getCopy('STORECLIENT_BREADCRUMB_NEW_CHATBOT') }}</a></li>
                    </ul>
                </nav>

                <div class="field">
                    <label class="label">{{ CONSTANTS.getCopy('STORECLIENT__NAME') }}</label>
                    <div class="control">
                        <input class="input" type="text" v-bind:placeholder="CONSTANTS.getCopy('STORECLIENT__NAME_PLACEHOLDER') " v-model="client.name">
                    </div>
                </div>

                <div class="field">
                    <label class="label">{{ CONSTANTS.getCopy('STORECLIENT__DESCRIPTION') }}</label>
                    <div class="control">
                        <input class="input" type="text" v-bind:placeholder="CONSTANTS.getCopy('STORECLIENT_DESCRIPTION_PLACEHOLDER') " v-model="client.description">
                    </div>
                </div>

                <br>

                <div class="button is-primary is-left" @click="storeClient">
                    <span class="icon"><i class="fas fa-save fa-lg"></i></span>
                    <span class="is-capitalized">{{ CONSTANTS.getCopy('STORECLIENT_BUTTON_SAVE') }}</span>
                </div>
            </div>

        </div>
    </div>

</template>

<script>
export default {
  data () {
    return {
      client: {name: null, description: null}
    }
  },
  methods: {
    storeClient () {
      this.api.post('/ClientRegister', this.client).then(() => {
        this.$router.back()
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/clients/StoreClient.vue